import { Col } from "react-bootstrap";
import "./ProjectCard.css";
import StackIcon from "tech-stack-icons";
import { motion } from "framer-motion";

export const ProjectCard = ({ title, techStack = [], imgUrl, source }) => {
  if (!title || !imgUrl) {
    return null;
  }

  return (
    <Col size={12} sm={6} md={4}>
      <motion.div
        className="project-card"
        whileHover={{
          y: -8,
          scale: 1.02,
          boxShadow: "0 10px 30px rgba(0,0,0,0.25)",
        }}
        whileTap={{ scale: 0.99 }}
        transition={{ type: "spring", stiffness: 300, damping: 20 }}
      >
        <a href={source} target="_blank" rel="noreferrer">
          <div className="proj-imgbx">
            <img src={imgUrl} alt="project" />
            <div className="proj-txtx">
              <h4 className="text-white">{title}</h4>
              <div className="tech-stack p-2">
                {techStack.map((tech) => (
                  // <img key={tech} src={tech} alt={tech} className="tech-icon"/>
                  <StackIcon className="tech-icon" name={tech} />
                ))}
              </div>
            </div>
          </div>
        </a>
      </motion.div>
    </Col>
  );
};
